(() => {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var parcelRequire = $parcel$global["parcelRequire94c2"];
parcelRequire.register("d9WzM", function(module, exports) {

$parcel$export(module.exports, "Video", () => $99498da206bb158e$export$ae01dedf5c052bb);
class $99498da206bb158e$export$ae01dedf5c052bb {
    constructor(selector){
        this.selector = selector;
    }
    load() {
        const button_load = this.selector.querySelector(".video .button");
        const video_url = this.selector.dataset.url;
        const video_disclaimer = this.selector.querySelector(".video-disclaimer");
        const video_width = this.selector.dataset.width ? this.selector.dataset.width : 640;
        const video_height = this.selector.dataset.height ? this.selector.dataset.height : 360;
        if (video_url) {
            const video_iframe = `<iframe width="${video_width}" height="${video_height}" src="${video_url}"
                allowfullscreen></iframe>`;
            button_load.addEventListener("click", ()=>{
                video_disclaimer.insertAdjacentHTML("beforebegin", video_iframe);
                video_disclaimer.remove();
            });
        }
    }
}

});

})();
//# sourceMappingURL=video.c9df4ed7.js.map
